import React, { useEffect, useState } from 'react';
import T from 'prop-types'

import './select.scss';

import axios from 'axios';

import makeAnimated from "react-select/animated";
import { components } from 'react-select';

import SelectExtendedAsync from "../Blocks/SelectExtendedAsync";
import SelectExtended from "../Blocks/SelectExtended";

const styles = {
  control: (base, state) => ({
    ...base,
    border: `1px solid #CED4DA`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid #CED4DA`,
    },
    fontFamily: "Montserrat",
    fontWeight: 400,
    borderRadius: 0,
    flexWrap: 'nowrap',
    marginRight: '1rem',
    height: '2.25rem',
    maxWidth: '16.8rem',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: 'none',
    '&:hover': { backgroundColor: '#EDEBF0' },
    color: 'black',
    fontWeight: 300,
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'capitalize',
    paddingRight: '1rem',
  }),
  valueContainer: (base, state) => ({
    ...base,
    textOverflow: "ellipsis",
    width: '16rem',
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "inline-block",
    marginRight: '4px',
    marginLeft: '2px',
    paddingLeft: '2px',
    paddingBottom: '0.2rem',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    paddingRight: '2px',
  }),
  menu: (base, state) => ({
    ...base,
    textOverflow: "ellipsis",
  }),
  menuList: (base, state) => ({
    ...base,
    maxHeight: '200px',
    textOverflow: 'ellipsis',
    overflowY: 'scroll',
  }),
};

const stylesBig = {
  ...styles,
  control: (base, state) => ({
    ...styles['control'](base, state),
    marginRight: 'auto',
    height: 'auto',
    maxWidth: 'none',
  }),
}

const Option = props => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          className='mr-3'
          checked={props.isSelected}
          onChange={() => null}
        />
        <label
            data-bs-toggle={props.label.length > 30 && 'tooltip'}
            style={{overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '12.5rem'}}
            title={props.label.length > 30 ? props.label: ''}
        >{props.label}</label>
      </components.Option>
    </div>
  );
};

const MultiValue = props => (
  props.data.value !== '*' &&
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);

const SingleValue = props => (
  props.data.value !== '*' &&
  <components.SingleValue {...props}>
    <span>{props.data.label}</span>
  </components.SingleValue>
);

const IndicatorsContainer = (selectProps) => {
  const selectedCount = selectProps.getValue().filter(option => option.value !== '*').length;

  return (
    <components.IndicatorsContainer {...selectProps}>
      { selectedCount > 0 && (<span className='select-container__selected_count'>{selectedCount}</span>) }
      <components.ClearIndicator {...selectProps} />
    </components.IndicatorsContainer>
  );
}

const animatedComponents = makeAnimated();

const Select = (props) => {
  const scope = props.scope === undefined ? '' : props.scope;
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState([]);

  useEffect(() => {
    let url = props.collection_url + '?scope=' + scope;
    if (props.selected_options !== undefined && props.selected_options !== null && props.selected_options.filter(option => option !== null && option !== undefined && option.length > 0).length > 0) {
      url += '&input_value=' + props.selected_options;
    } else if (props.async === true) {
      return;
    }


    axios.get(url).then((response) => {
      const loadedOptions = response.data.data.map((item) => {
        return {value: item.id, label: item.name}
      });

      const selectedOptions = props.selected_options
        ?
        props.selected_options.map((selected_option) => {
          return loadedOptions.find((option) => {
            return option.value !== null && option.value !== undefined && option.value.toString() === selected_option.toString()
          })
        }).filter((option) => {
          return option !== null && option !== undefined;
        })
        :
        [];

      if (props.allow_empty) {
        setOptions([{value: '', label: 'Empty'}, ...loadedOptions]);
      } else {
        setOptions(loadedOptions);
      }

      setValue(selectedOptions);
    });
  }, []);

  const onChange = selected => {
    setValue(selected);
  };

  return (
    <>
      {props.label && <div className='select-container__label'>{props.label}</div>}
      <div className='select-container'>
        { props.async ? (
            <SelectExtendedAsync
              value={value}
              isMulti={props.multi}
              styles={props.class_name === 'big' ? stylesBig : styles}
              isClearable={true}
              name={props.name}
              className={`custom-multi-select ${props.class_name}`}
              classNamePrefix="select"
              onChange={onChange}
              components={{Option, IndicatorsContainer, MultiValue, SingleValue, animatedComponents}}
              options={options}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              placeholder={null}
              allowSelectAll={true}
              isSearchable={props.search}
              url={props.collection_url}
            /> )
          : (
            <SelectExtended
              value={value}
              isMulti={props.multi}
              styles={props.class_name === 'big' ? stylesBig : styles}
              isClearable={true}
              name={props.name}
              className={`custom-multi-select ${props.class_name}`}
              classNamePrefix="select"
              onChange={onChange}
              components={{Option, IndicatorsContainer, MultiValue, SingleValue, animatedComponents}}
              options={options}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              placeholder={null}
              allowSelectAll={props.multi}
              isSearchable={props.search}
              url={props.collection_url}
            /> )
        }
      </div>
    </>
  )
};

Select.propTypes = {
  class_name: T.string,
  collection_url: T.string,
  multi: T.bool,
  async: T.bool,
  search: T.bool,
  allow_empty: T.bool,
  label: T.string,
  name: T.string,
  selected_options: T.array,
  scope: T.string,
};

export default Select;
